export const CMS_PERMISSIONS = {
  analytics: {
    viewAny: 'analytics.viewAny',
  },
  audits: {
    viewAny: 'audits.viewAny',
  },
  categories: {
    viewAny: 'categories.viewAny',
    view: 'categories.view',
    create: 'categories.create',
    update: 'categories.update',
    delete: 'categories.delete',
  },
  enclaves: {
    viewAny: 'enclaves.viewAny',
    view: 'enclaves.view',
    create: 'enclaves.create',
    update: 'enclaves.update',
    delete: 'enclaves.delete',
  },
  marketing: {
    manage: 'marketing.manage',
  },
  media: {
    upload: 'media.upload',
    delete: 'media.delete',
  },
  news: {
    viewAny: 'news.viewAny',
    view: 'news.view',
    create: 'news.create',
    update: 'news.update',
    delete: 'news.delete',
  },
  notifications: {
    send: 'notifications.send',
  },
  routes: {
    viewAny: 'routes.viewAny',
    view: 'routes.view',
    create: 'routes.create',
    update: 'routes.update',
    delete: 'routes.delete',
  },
  users: {
    viewAny: 'users.viewAny',
    create: 'users.create',
    update: 'users.update',
    delete: 'users.delete',
  },
  zones: {
    viewAny: 'zones.viewAny',
    view: 'zones.view',
  },
} as const;
